import { createFileRoute } from '@tanstack/react-router'
import { AutomationsPage } from '@/pages/automations/automations-page'
import { WorkspaceEntitlementGate } from '@/features/workspace-entitlements/ui/workspace-entitlement-gate'
import { WorkspaceEntitlementKey } from '@/graphql/schema'

export const Route = createFileRoute('/automations/')({
  component: () => (
    <WorkspaceEntitlementGate feature={WorkspaceEntitlementKey.Automations}>
      <AutomationsPage />
    </WorkspaceEntitlementGate>
  ),
})
